const BOOKINGS_KEY = 'inkhaus.bookings';
const NEWSLETTER_KEY = 'inkhaus.newsletter';

export type StoredBooking = {
  code: string;
  createdAt: string;
  name: string;
  email: string;
  phone?: string;
  artistSlug: string;
  style: string;
  idea: string;
  timeframe: string;
  budget: string;
  language: string;
};

function safeParse<T>(value: string | null, fallback: T): T {
  if (!value) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
}

export function readBookings(): StoredBooking[] {
  if (typeof window === 'undefined') return [];
  return safeParse<StoredBooking[]>(window.localStorage.getItem(BOOKINGS_KEY), []);
}

export function saveBooking(booking: StoredBooking) {
  if (typeof window === 'undefined') return;
  const existing = readBookings();
  const next = [booking, ...existing].slice(0, 20);
  window.localStorage.setItem(BOOKINGS_KEY, JSON.stringify(next));
}

export function generateBookingCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let out = '';
  for (let i = 0; i < 6; i++) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return `IK-${out}`;
}

export function readNewsletter(): string[] {
  if (typeof window === 'undefined') return [];
  return safeParse<string[]>(window.localStorage.getItem(NEWSLETTER_KEY), []);
}

export function saveNewsletter(email: string) {
  if (typeof window === 'undefined') return;
  const existing = readNewsletter();
  if (existing.includes(email)) return;
  window.localStorage.setItem(NEWSLETTER_KEY, JSON.stringify([email, ...existing]));
}
